import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  class: "row",
  style: {"width":"100%","margin-right":"0","margin-left":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PublicPageView = _resolveComponent("PublicPageView")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (publicPage) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "projectListItem",
        key: publicPage.id
      }, [
        _createVNode(_component_PublicPageView, { publicPage: publicPage }, null, 8, ["publicPage"])
      ]))
    }), 128))
  ]))
}